export default __webpack_public_path__ + "static/media/ART13.72452932.jpg";